// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/images/chat-background-pattern.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout--chat[data-v-687ac46a]{height:100%}@media only screen and (min-width: 1121px){.layout--chat[data-v-687ac46a]{background-color:#dcd5f1;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
